export default () => ({
  referralCode: '',
  currency: 'EUR',
  amount: 0
})
